(() => {
  if (window.bbbChoicesLoaded) return;
  window.bbbChoicesLoaded = true;
  const values = el => { const v = JSON.parse(el.dataset.choiceValues); return Array.isArray(v) ? v : [v]; };
  function tagContext(el, url) {
    const root = el.closest('[data-bbb-choices]');
    const base = new URL(root.dataset.choiceBase, location.origin).pathname.replace(/\/$/, '');
    const tags = decodeURIComponent(url.pathname.slice(base.length)).replace(/^\//, '').split('+').filter(Boolean);
    const managed = new Set([...root.querySelectorAll('[data-choice-tag]')].map(a=>a.dataset.choiceTag));
    managed.add('strømpebukserogsokkerstrømpebukser');
    const isCategory = tag => managed.has(tag) || /^000-bbb-(cat|nav|family)-/.test(tag) || /^000-bbb-root-(tilbehor|yttertoy|mellomlag|utstyr)$/.test(tag);
    return { base, tags, isCategory };
  }
  function urlFor(el) {
    const url = new URL(location.href);
    if (el.dataset.choiceCategory) {
      const { base, tags, isCategory } = tagContext(el, url);
      const nextTags = tags.filter(tag=>!isCategory(tag));
      if (el.dataset.choiceTag) nextTags.push(el.dataset.choiceTag);
      url.pathname = base + (nextTags.length ? '/' + nextTags.map(encodeURIComponent).join('+') : '');
      url.searchParams.delete('filter.p.tag');
    }
    url.searchParams.delete(el.dataset.choiceParam);
    values(el).forEach(v => url.searchParams.append(el.dataset.choiceParam, v));
    url.searchParams.delete('page');
    url.hash = 'CollectionAjaxContent';
    return url;
  }
  function refresh() {
    document.querySelectorAll('[data-bbb-choices] [data-choice-param]').forEach(a => {
      const current = new URL(location.href);
      const selected = current.searchParams.getAll(a.dataset.choiceParam).flatMap(x=>x.split(','));
      const vv = values(a);
      a.href = urlFor(a).href;
      const { tags, isCategory } = tagContext(a, current);
      const tagMatches = !a.dataset.choiceCategory || (a.dataset.choiceTag ? tags.includes(a.dataset.choiceTag) : !tags.some(isCategory));
      const matches = vv.length === selected.length && vv.every(v=>selected.includes(v));
      if (tagMatches && matches) a.setAttribute('aria-current','true');
      else a.removeAttribute('aria-current');
    });
  }
  document.addEventListener('click',e=>{
    const a=e.target.closest('[data-bbb-choices] [data-choice-param]');
    if (!a || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    a.href=urlFor(a).href;
  },true);
  let scheduled=false;
  const observer=new MutationObserver(list=>{
    if(!list.some(m=>[...m.addedNodes].some(n=>n.nodeType===1&&(n.matches?.('[data-bbb-choices]')||n.querySelector?.('[data-bbb-choices]')))))return;
    if(!scheduled){scheduled=true;requestAnimationFrame(()=>{scheduled=false;refresh();});}
  });
  function init(){refresh();observer.observe(document.body,{childList:true,subtree:true});}
  if(document.body)init();else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('DOMContentLoaded',refresh);
  window.addEventListener('popstate',refresh);
  document.addEventListener('shopify:section:load',refresh);
})();


